// Libs
import React from "react";
import { Card } from "antd";

// Components
import DashboardContentsManageLink from "components/contents/dashboard/manage-link";

// Styles
import s from "./index.module.scss";

function DashboardManageLink() {
  return (
    <>
      <Card className={s.container}>
        <section className={s.section}>
          <DashboardContentsManageLink />
        </section>
      </Card>
    </>
  );
}

export default DashboardManageLink;
